module.exports = __webpack_public_path__ + "assets/clock_alert-089d20.svg";